import AdultTraveller from './adult/adultTraveller.directive';
import TravellerProfileConfirmationMessage from './adult/traveller-profile-confirmation-message/traveller-profile-confirmation-message-module';
import RefreshTravellerDetailsPopup from './refresh-traveller-details-popup/refresh-traveller-details-popup-module';

import AdultTravellerService from './adult/adult-traveller-service';
import TravellerProfileEmailExistence from './adult/traveller-profile-email-existence-directive';
import FFNManagementModule from './adult/ffn-management/ffn-management-module';

const MODULE_NAME = 'App.Trip.travellers';
const module = angular.module(MODULE_NAME, [
    TravellerProfileConfirmationMessage,
    FFNManagementModule,
    RefreshTravellerDetailsPopup,
])
    .directive(AdultTraveller.DIRECTIVE_NAME, AdultTraveller)
    .service(AdultTravellerService.SERVICE_NAME, AdultTravellerService)
    .directive('ktTravellerProfileEmailExistence', TravellerProfileEmailExistence);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/travellers-module.js